import { HeroFramed as HeroFramedUI } from "@repo/ui-parkmobile/HeroFramed";
import type { HeroFramed } from "@/generated/sb";
import {
  imageStoryblokResolver,
  sectionTitleResolver,
} from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";
import {
  getSectionName,
  getContentDescription,
  injectButtonAnalytics,
} from "@/utils/analytics";

interface HeroFramedProps {
  blok: HeroFramed;
}

export default function HeroFramed({ blok }: HeroFramedProps) {
  if (!blok) {
    return null;
  }

  const imageBlok = blok.backgroundImage?.[0];
  const imageAsset = imageStoryblokResolver(imageBlok);

  const sectionTitle = blok.title
    ? sectionTitleResolver(blok.title)
    : undefined;

  const sectionName =
    sectionTitle?.typography?.find((item) => item.type === "title")?.content ||
    getSectionName(blok.title) ||
    "Hero Framed";

  const contentDescription = getContentDescription(blok.title);

  if (sectionTitle) {
    sectionTitle.buttons = injectButtonAnalytics(
      sectionTitle.buttons,
      sectionName,
      contentDescription,
    );
  }

  return (
    <HeroFramedUI
      {...storyblokEditable(blok)}
      image={imageAsset}
      backgroundOverlay={blok.backgroundOverlay || "brand-50"}
      backgroundOverlayColor={"primary"}
      imageAlignment={
        blok.imageAlignment === "top" || blok.imageAlignment === "bottom"
          ? blok.imageAlignment
          : "middle"
      }
      title={sectionTitle || undefined}
      backgroundColor={blok.backgroundColor || "none"}
      topPadding={blok.topPadding || "none"}
      bottomPadding={blok.bottomPadding || "none"}
      id={blok.anchor}
    />
  );
}
